import Vue from 'vue'
import configs from '@/config'
import { SimpleCache } from '@/utils/cache.utils'

let resource = null

export const actions = {
  getUserPlanBenefit: {
    method: 'GET',
    url: `${configs.baseUrl}/api/plan-benefit/plan`,
  },
  getUserLimitationPresentation: {
    method: 'GET',
    url: `${configs.baseUrl}/api/plan-benefit/presentation/{presentationId}/enforce-slidetype`,
  },
  getDataPresentationHandleCopyPlanBenefit: {
    method: 'GET',
    url: `${configs.baseUrl}/api/plan-benefit/presentation/{presentationId}/get-enforce-feature`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getUserPlanBenefit = async (params) => {
  const res = await resource.getUserPlanBenefit(params)
  return res.body
}

const getUserLimitationPresentation = async (presentationId, params) => {
  const payload = { ...params, presentationId }
  const res = await resource.getUserLimitationPresentation(payload)
  return res.body
}

const getDataPresentationHandleCopyPlanBenefit = async (presentationId, params) => {
  const payload = { ...params, presentationId }
  const res = await resource.getDataPresentationHandleCopyPlanBenefit(payload)
  return res.body
}

const cache = new SimpleCache()

const getUserPlanBenefitWithCache = async ({ maxAgeInSeconds = 1 }) => {
  return cache.invoke(() => {
    return getUserPlanBenefit()
  }, {
    key: 'getUserPlanBenefit',
    maxAgeInSeconds,
  })
}

export default {
  initResource,
  getUserPlanBenefit,
  getUserPlanBenefitWithCache,
  getUserLimitationPresentation,
  getDataPresentationHandleCopyPlanBenefit,
}
